


import React from 'react';
import { Link } from 'react-router-dom';
const HeroLanding = () => {
  // Define color constants with precise hex codes
  const COLORS = {
    white: "#FFFFFF",
    violet: "#5941D9",
    deepViolet: "#3E2DA0",
    lightViolet: "#8466E2",
    veryLightViolet: "#F2EEFF",
    black: "#1A1A1A",
    gray: "#666666",
    lightGray: "#F0F0F0",
    cardShadow: "rgba(89, 65, 217, 0.1)"
  };

  return (
    <div className="relative overflow-hidden" style={{ backgroundColor: COLORS.white }}>
      {/* Background shapes - subtle and elegant */}
      <div className="absolute top-0 right-0 w-full h-full" style={{ zIndex: 0 }}>
        {/* Top right corner shape */}
        <div className="absolute top-0 right-0 w-96 h-96"
          style={{
            backgroundColor: COLORS.veryLightViolet,
            borderRadius: "0 0 0 100%",
            opacity: 0.7
          }}>
        </div>
        
        {/* Middle left shape */}
        <div className="absolute top-1/4 left-0 w-64 h-64"
          style={{
            backgroundColor: COLORS.veryLightViolet,
            borderRadius: "0 100% 100% 0",
            opacity: 0.5
          }}>
        </div>
        
        {/* Bottom right shape */}
        <div className="absolute bottom-0 right-1/4 w-80 h-80"
          style={{
            backgroundColor: COLORS.veryLightViolet,
            borderRadius: "100% 100% 0 0",
            opacity: 0.3
          }}>
        </div>
        
        {/* Decorative dots pattern */}
        <div className="absolute top-1/3 left-1/3 w-full h-full">
          <div className="relative w-full h-full">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="absolute w-4 h-4 rounded-full"
                style={{
                  backgroundColor: COLORS.lightViolet,
                  opacity: 0.2,
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`
                }}>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 lg:px-12  relative z-10">
        {/* Hero content */}
        <div className="flex flex-col-reverse lg:flex-row items-center py-4">
          <div className="w-full lg:w-1/2  lg:mt-0 lg:pr-12">
            {/* Heading with accent line */}
            <div className="relative mb-6">
              <div className="absolute left-0 top-0 w-20 h-2 rounded-full"
                style={{ backgroundColor: COLORS.violet }}></div>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6"
              style={{ color: COLORS.black }}>
              <span className='text-4xl md:text-3xl lg:text-4 '>Built on Trust.</span>
              <span className="block mt-2 text-2xl md:text-3xl lg:text-3xl " style={{ color: COLORS.violet }}>
                IV&V and Quality Assurance Testing
              </span>
            </h1>
            
            <p className="text-xl leading-relaxed mb-10"
              style={{ color:"black", maxWidth: "90%" }}>
              Ensure your software meets quality and compliance standards with our Independent Verification and Validation (IV&V) Testing. We identify issues early and verify requirements, so your product works as intended.
            </p>
            
            <div className="flex items-center space-x-6">
              <Link
                to={"/contact" }
                style={{ 
                  backgroundColor: COLORS.violet, 
                  color: COLORS.white,
                  boxShadow: `0 12px 20px -10px ${COLORS.violet}80`,
                  transition: 'all 0.3s ease-in-out'
                }} 
                className="px-8 py-4 rounded-full text-lg font-semibold hover:shadow-lg transform hover:-translate-y-1"
              >
                Schedule a Demo
              </Link>
              
              
            </div>
          </div>
          
          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative">
              {/* Image decorative border */}
              <div className="absolute inset-0 rounded-full border-4 border-dashed"
                style={{ 
                  borderColor: COLORS.lightViolet,
                  transform: 'scale(1.1) rotate(5deg)'
                }}>
              </div>
              
              {/* Image frame */}
              <div className="relative overflow-hidden "
                style={{ 
                  boxShadow: `0 20px 40px -15px ${COLORS.cardShadow}`,
                  border: `4px solid ${COLORS.white}`
                }}>
                <img
                  src="https://ik.imagekit.io/kqumni8l2/Testing%20page/software%20tester-pana.png?updatedAt=1747026313534" // Replace with your GIF path
                  alt="KCS Tech Testing Services"
                  className="w-full max-w-md lg:max-w-lg h-[400px]"
                />
                
                {/* Highlight accent */}
                <div className="absolute top-0 right-0 w-20 h-20 rounded-full"
                  style={{ 
                    background: `radial-gradient(circle, ${COLORS.violet}30 0%, transparent 70%)`,
                    transform: 'translate(25%, -25%)'
                  }}>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Section with elegant cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16 mb-10">
          {[
            { 
              icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/BG/Cup.png?updatedAt=1747027870543", 
              number: "5+", 
              text: "Years in the Business" 
            },
            { 
              icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/BG/ShakeHand.png?updatedAt=1747027870138", 
              number: "60+", 
              text: "Global Clients" 
            },
            { 
              icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/BG/TestingPage.png?updatedAt=1747027870527", 
              number: "250+", 
              text: "Successful Projects" 
            },
            { 
              icon:"https://ik.imagekit.io/kqumni8l2/Testing%20page/BG/Star.png?updatedAt=1747027870572", 
              number: "4.8", 
              text: "Clients Rate Us" 
            }
          ].map((stat, index) => (
            <div key={index} 
              className="bg-white rounded-xl p-6 transition-all duration-300 hover:shadow-xl"
              style={{ 
                border: `1px solid ${COLORS.lightGray}`,
                boxShadow: `0 10px 30px -10px ${COLORS.cardShadow}`
              }}>
              <div className="flex items-start">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4"
                  style={{ 
                    // backgroundColor: COLORS.veryLightViolet,
                    // color: COLORS.violet
                  }}>
                  <div className="text-3xl font-bold"><img src={stat.icon} alt={stat.text} /></div>
                </div>
                <div>
                  <div className="text-2xl font-bold mb-1"
                    style={{ color: COLORS.black }}>
                    {stat.number}
                  </div>
                  <div style={{ color: COLORS.black }}>
                    {stat.text}
                  </div>
                </div>
              </div>
              
              {/* Bottom accent line */}
              <div className="w-12 h-1 mt-4 rounded-full"
                style={{ backgroundColor: COLORS.violet, opacity: 0.7 }}></div>
            </div>
          ))}
        </div>
        
        {/* Trust badge section */}
        {/* <div className="mt-20 text-center">
          <div className="inline-block px-6 py-2 rounded-full mb-8"
            style={{ backgroundColor: COLORS.veryLightViolet }}>
            <span style={{ color: COLORS.violet }} className="text-sm font-medium">
              TRUSTED BY INDUSTRY LEADERS
            </span>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-10 opacity-60">
            {[1, 2, 3, 4, 5].map((num) => (
              <div key={num} className="w-32 h-12 rounded-md bg-gray-200"></div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default HeroLanding;